import { render, staticRenderFns } from "./businessPoints.vue?vue&type=template&id=1aba808d&"
import script from "./businessPoints.vue?vue&type=script&lang=js&"
export * from "./businessPoints.vue?vue&type=script&lang=js&"
import style0 from "./businessPoints.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports